<template>
  <v-footer dark padless>
    <v-card class="flex" flat tile>
      <v-card-title class="primary">
        <strong class="subheading">CIT UNDB</strong>

        <v-spacer></v-spacer>

        <v-btn class="mx-2" dark icon href="https://sou.undb.edu.br" title="Web" target="_blank" >
          <v-icon size="20px">mdi-web</v-icon>
        </v-btn>

        <v-btn class="mx-2" dark icon title="E-mail" href="mailto:reserva_laboratorio@undb.edu.br" target="_blank" >
          <v-icon size="20px">mdi-email</v-icon>
        </v-btn>

      </v-card-title>

      <v-card-text class="py-2 white--text text-center" >
        <strong>Centro Universitário UNDB</strong> — {{ new Date().getFullYear() }}  
      </v-card-text>
    </v-card>
  </v-footer>
</template>


<script>
  export default {
  }
</script>